"use client"
import React from "react";
import Accordion from "../../Atoms/Accordion";
import Playfair40pxSemibold from "../../Atoms/Typography/Playfair40pxSemibold";
import { FAQ_SLICE_CONTAINER, QUESTIONS_CONTAINER } from "./styles";
import { FAQ_ID } from "./constants";
import { GoogleTagManagerEvents } from "../../../common";
import useStore from "@/lib/Store/useStore";
import { injectDynamicContentIntoArray } from "@/components/utils/utils";
import { faqSpendPerItem, getDeliveryDaysByISO } from "@/public/Constants/CountriesList";

const FaqSlice = ({ slice }) => {
    const { price, currency, flag } = useStore()

    const updateContent = (contentArray) => {
        const SpendPerItem = faqSpendPerItem?.[currency]
        const values = {
            "styling-fee": `${price}`,
            currency: `${currency}`,
            "shipping-days": getDeliveryDaysByISO(flag),
            ...SpendPerItem

        };
        return injectDynamicContentIntoArray(contentArray, values)
    }

    return (
        <div className={FAQ_SLICE_CONTAINER}>
            <Playfair40pxSemibold text={slice?.primary?.title} />
            <div className={QUESTIONS_CONTAINER}>
                {slice?.items?.map((item, index) => (
                    <Accordion
                        isGTMEvent={true}
                        gtmObj={{
                            event: GoogleTagManagerEvents.clickInteractions,
                            place: "Faq",
                            menu_name: item?.question,
                        }}
                        question={updateContent(item?.question)}
                        answer={updateContent(item?.answer)}
                        id={index + FAQ_ID}
                        image={item?.answer_image}
                        key={index + FAQ_ID}
                    />
                ))}
            </div>
        </div>
    );
};

export default FaqSlice;
